(function () {
  function closeItem(titleEl) {
    const content = titleEl.nextElementSibling;
    const icon = titleEl.querySelector('span');
    if (!content) return;
    content.style.height = '0';
    titleEl.classList.remove('open');
    content.classList.remove('open');
    if (icon) icon.classList.remove('open');
  }

  function openItem(titleEl) {
    const content = titleEl.nextElementSibling;
    const icon = titleEl.querySelector('span');
    if (!content) return;
    content.style.height = content.scrollHeight + 'px';
    titleEl.classList.add('open');
    content.classList.add('open');
    if (icon) icon.classList.add('open');
  }

  function bindSection(root) {
    const titles = root.querySelectorAll('.faq__item-title');
    const handle = root.getAttribute('data-product-handle') || '';
    const isPilEssKitTemplate =
      document.body.dataset.template === 'product.pil-ess-kit-lp-store';
    const guideTemplates = ['gift-guide', 'bra-guide', 'leggings-guide'];

    titles.forEach((t, index) => {
      t.addEventListener('click', () => {
        const content = t.nextElementSibling;
        if (!content) return;
        const isOpen = content.classList.contains('open');

        if (isOpen) {
          closeItem(t);
        } else {
          root.querySelectorAll('.faq__item-title.open').forEach(closeItem);
          openItem(t);

          root.dispatchEvent(
            new CustomEvent('faq:toggle', {
              detail: {
                question: t.textContent.trim(),
                isOpen: true,
                productHandle: handle
              }
            })
          );

          // faq event click
          window.dataLayer = window.dataLayer || [];
          const pathParts = window.location.pathname.split('/').filter(Boolean);
          const from = pathParts[pathParts.length - 1];
          let type;
          if (handle) {
            type = 'product';
          } else if (
            document.body.dataset.template.includes('capsule') ||
            document.body.dataset.template.includes('best-of-betterme')
          ) {
            type = 'capsule';
          } else if (
            guideTemplates.some(guide =>
              document.body.dataset.template.includes(guide)
            )
          ) {
            type = 'gift-guide';
          } else if (document.body.dataset.template.includes('black-friday')) {
            type = 'black_friday';
          } else {
            type = 'does_not_set';
          }
          window.dataLayer.push({
            event: 'custom_event',
            event_name: 'faq_click',
            parameter: JSON.stringify({
              faq_number: `${index + 1}`,
              type,
              from
            })
          });
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-faq-root]').forEach(bindSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
